module.exports = __webpack_public_path__ + "pic2.jpg?c56abc0a0482e7fda1ceba27dc3f6081";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/grid/pic2.jpg
// module id = 58
// module chunks = 13